<template>
<div class="s-educativa">
  <div class="s-educativa__tabs">
    <div class="s-educativa__tab">Carrera</div>
    <div class="s-educativa__add">+</div>
  </div>

  <div class="s-educativa__body">

    <md-autocomplete v-model="ldata.country" :md-options="countries" required>
      <label>País</label>
    </md-autocomplete>

    <md-autocomplete v-model="ldata.college" :md-options="colleges" required>
      <label>Institución educativa</label>
    </md-autocomplete>

    <md-autocomplete v-model="ldata.profesion" :md-options="profesions" required>
      <label>Carrera o Área de Formación</label>
    </md-autocomplete>

    <md-autocomplete v-model="ldata.level" :md-options="levels" required>
      <label>Nivel de Estudio</label>
    </md-autocomplete>

    <md-field>
      <label>Año de egreso</label>
      <md-input v-model="ldata.finalyear"></md-input>
    </md-field>



  </div>
    <md-button
      class="md-raised md-accent s-educativa__save">
      Guardar
    </md-button>
</div>
</template>

<script>
export default {
  props: {
    value: Object
  },
  created(){

  },
  data(){
    return{
      ldata: {
      },
      countries: [
        'Perú',
        'Brasil',
        'Chile'
      ],
      colleges: [
        'Universidad Nacional Mayor de San Marcos',
        'Universidad Nacional de Ingeniería',
        'Pontifici Universidad Católica del Perú',
        'Instituto Cibertec'
      ],
      profesions: [
        'Ingeniería de Software',
        'Medicina Humana',
        'Arquitectura',
        'Diseño Gráfico'
      ],
      levels: [
        'Eduación Secundaria Incompleta',
        'Educación Técnica Completa',
        'Educación Universitaria Completa'
      ]

    }
  }
}
</script>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #C63832;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: "../assets/img/";
//3-TOOLS
//functions
//background-image function
@function bimg($img) {
  @return url($p-img+$img);
}
//mixins
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}

//8-TRUMPS
//vue-material
.md-field {
  width: 18rem;
  // margin: 0 2rem 2rem 24px;

  &.md-theme-default {
    label {
      color: rgba($b-blue, 0.6);
      &::after {
        color: $b-orange;
      }
    }
    &::after {
      background-color: #d7dae2;
    }
    &::before {
      background-color: $b-blue;
    }
    &.md-focused {
      label {
        color: $b-blue-dark;
      }
    }

    &.md-invalid {
      label {
        color: $b-orange;
      }
      &::after {
        background-color: $b-orange;
      }
      .md-error {
        color: $b-orange;
      }
    }
  }
}

.md-menu-content{
  z-index: 600;
}

.s-educativa{
  &__tabs{
    display: flex;
    padding-left: 1rem;
    @include mq($sm){
      padding-left: 3rem;
    }
  }
  &__tab{
    padding: 0.5rem 1rem 0.5rem 0.5rem;
    background-color: #e6e6e6;
    color: $b-blue-dark;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    margin-right: 3px;
    margin-top: 0.5rem;
    transition: background-color .3s ease-in-out;
    @include mq($md) {
      cursor: pointer;
    }
  }

  &__add{
    padding: 0.5rem 0;
    background-color: $b-orange;
    color: white;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    margin-right: 3px;
    margin-top: 0.5rem;
    width: 2.5rem;
    font-size: 1.5rem;
    font-weight: bold;
    text-align: center;
    @include mq($md){
      cursor: pointer;
    }
  }

  &__body{
    padding: 1rem 1rem 3rem 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    @include mq($sm){
      padding: 1rem 3rem 3rem 3rem;
      width: 90%;
      max-width: 51rem;
    }
    @include mq($md) {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
    }
  }

  &__save{
    color: #fff !important;
    width: 15rem;
    margin: 1rem auto;
    @include mq($md){
      width: 16rem;
      margin: 1rem auto 0 auto;
    }
  }

}
</style>
